import dayjs from 'dayjs';
import { useMemo } from 'react';

const months = [
    i18next.t('useGetFormattedGrouperTitle.months.january'),
    i18next.t('useGetFormattedGrouperTitle.months.february'),
    i18next.t('useGetFormattedGrouperTitle.months.march'),
    i18next.t('useGetFormattedGrouperTitle.months.april'),
    i18next.t('useGetFormattedGrouperTitle.months.may'),
    i18next.t('useGetFormattedGrouperTitle.months.june'),
    i18next.t('useGetFormattedGrouperTitle.months.july'),
    i18next.t('useGetFormattedGrouperTitle.months.august'),
    i18next.t('useGetFormattedGrouperTitle.months.september'),
    i18next.t('useGetFormattedGrouperTitle.months.october'),
    i18next.t('useGetFormattedGrouperTitle.months.november'),
    i18next.t('useGetFormattedGrouperTitle.months.december'),
];

export const useGetFormattedGrouperTitle = (grouperTitle: string) => {
    return useMemo(() => {
        const isValidDate = dayjs(grouperTitle, 'YYYY-MM-DD', true).isValid();
        if (!isValidDate) return { formattedTitle: grouperTitle };

        const today = dayjs().startOf('day');
        const tomorrow = today.add(1, 'day').startOf('day');
        const inputDate = dayjs(grouperTitle, 'YYYY-MM-DD').startOf('day');

        const day = inputDate.date();
        const month = months[inputDate.month()];
        const year = inputDate.year();
        const dateString = `${day} ${month}`;

        let result = grouperTitle;

        if (inputDate.isSame(today)) {
            result = month;
        } else if (inputDate.isSame(tomorrow)) {
            result = month;
        } else if (year === dayjs().year()) {
            result = month;
        } else {
            result = `${month} ${year}`;
        }

        return { formattedTitle: result };
    }, [grouperTitle]);
};
